// Module
var code = "<react-component name=\"ChangelogList\"></react-component>\n";
// Exports
module.exports = code;